import { TenantAuthorizationData } from '../../../../context/auth';
import apiClient from './apiClient';

interface TenantID {
	tenantId: string;
}

export interface TenantResponse {
	locator: string;
	hostname: string;
}

const TENANTS_KEY = 'tenants';

const getTenantsList = async (authToken: string): Promise<TenantResponse[]> => {
	const res = await apiClient.get(`/tenant/v1/tenants`, {
		headers: {
			Authorization: authToken,
		},
	});

	return res.data;
};

const authorizeTenant = async (
	authToken: string,
	body: TenantID,
): Promise<TenantAuthorizationData> => {
	const res = await apiClient.post(
		`/account/v1/authorization/update/tenant`,
		body,
		{
			headers: {
				Authorization: authToken,
			},
		},
	);

	return res.data;
};

const TenantsAPI = {
	getTenantsList,
	authorizeTenant,
	TENANTS_KEY,
};

export default TenantsAPI;
